import { render, staticRenderFns } from "./VacationApprovedWidget.vue?vue&type=template&id=97d53518&scoped=true&"
import script from "./VacationApprovedWidget.vue?vue&type=script&lang=js&"
export * from "./VacationApprovedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d53518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97d53518')) {
      api.createRecord('97d53518', component.options)
    } else {
      api.reload('97d53518', component.options)
    }
    module.hot.accept("./VacationApprovedWidget.vue?vue&type=template&id=97d53518&scoped=true&", function () {
      api.rerender('97d53518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/vacations/widgets/VacationApprovedWidget.vue"
export default component.exports